var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92:6394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7853 13.4466L15.9999 7.23197L22.2175 13.4493L25.8335 9.8333L15.9999 0L6.16958 9.83036L9.78543 13.4463L9.7853 13.4466ZM0 15.9999L3.61611 12.3833L7.23197 15.9992L3.61586 19.6153L0 15.9999ZM9.7853 18.5537L15.9999 24.7679L22.2174 18.5507L25.8353 22.1648L25.8335 22.1667L15.9999 31.9999L6.16958 22.1695L6.16446 22.1644L9.78569 18.5533L9.7853 18.5537ZM24.7679 16.0015L28.384 12.3854L31.9999 16.0012L28.3839 19.6173L24.7679 16.0015Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6674 15.9981H19.6689L16 12.3289L13.2881 15.04L12.9765 15.3517L12.334 15.9944L12.3289 15.9994L12.334 16.0046L16 19.6712L19.6692 16.0019L19.671 15.9999L19.6677 15.9981",
    fill: "#F3BA2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92:6394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.9999,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.395e9cbd.svg";
export { ForwardRef as ReactComponent };